import { DashboardLayout } from "@/components/DashboardLayout";
import { LifeBuoy, Mail, PhoneCall, MapPin } from "lucide-react";
import { useSiteConfig, useSupportPhone } from "@/context/SiteConfigContext";

export default function HelpPage() {
  const { config } = useSiteConfig();
  const { display: phoneDisplay, telHref } = useSupportPhone();
  const email = config.support_email || "info@stewardindia.com";
  return (
    <DashboardLayout title="Help & Support" breadcrumbs={["Support"]}>
      <div className="max-w-3xl space-y-6" data-testid="help-page">
        <div className="rounded-2xl border border-slate-200 bg-white p-6">
          <div className="flex items-center gap-4">
            <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#329112]/10 text-[#329112]"><LifeBuoy className="h-5 w-5" /></div>
            <div>
              <h2 className="text-lg font-bold text-slate-900">We're here to help.</h2>
              <p className="text-sm text-slate-600">Reach out to your organization admin or the Steward support desk.</p>
            </div>
          </div>
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#101876]/5 text-[#101876]"><Mail className="h-4 w-4" /></div>
            <div className="mt-4 text-xs font-bold uppercase tracking-widest text-slate-500">Email</div>
            <a href={`mailto:${email}`} className="text-sm font-semibold text-slate-900 hover:text-[#101876]" data-testid="help-email">{email}</a>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#101876]/5 text-[#101876]"><PhoneCall className="h-4 w-4" /></div>
            <div className="mt-4 text-xs font-bold uppercase tracking-widest text-slate-500">Call</div>
            <a href={telHref} className="text-sm font-semibold text-slate-900 hover:text-[#101876]" data-testid="help-phone">{phoneDisplay}</a>
          </div>
          <div className="rounded-2xl border border-slate-200 bg-white p-6 sm:col-span-2">
            <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#101876]/5 text-[#101876]"><MapPin className="h-4 w-4" /></div>
            <div className="mt-4 text-xs font-bold uppercase tracking-widest text-slate-500">Head Office</div>
            <div className="text-sm font-semibold text-slate-900" data-testid="help-address">2nd Floor, SCO 23, Hi Street, Eldeco Estate One, Panipat-132103, Haryana, India</div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
